export const playSound = (soundPath: string) => {
  const sound = new Audio(soundPath);
  // avoid error
  // DOMException: play() failed because the user didn't interact with the document first
  sound.play().then().catch(console.log);
};
